import React, { Component } from "react";
export class HelpDocuments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: props.message
    };
  }
  render() {
    
    return (
      <React.Fragment>
        <span className="small">
                  {this.state.message}{" "}
                  <button
                    id="LinkButtonHelp"
                    onClick={() => {
                        let url = "https://cloudcover365.virtualdcs.co.uk/helpme/login.html";
                        window.open(url, '_blank');
                    }}
                    style={{
                        backgroundColor: "transparent",
                      border: "none",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    View our Help page
                  </button>
                </span>      
        </React.Fragment>
    );
  }
}
